import { useEffect } from 'react';
export function DocumentTitle({
  title
}) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;
    return () => {
      document.title = prevTitle;
    };
  }, [title]);
  return null;
}